import VariantSelection from "./VariantSelection";
export default VariantSelection;
